import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach token from localStorage automatically
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Don't set Content-Type for FormData, let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
  } catch {}
  return config;
});

// Upload API
export const uploadAPI = {
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

// Releases API
export const releasesAPI = {
  getAll: () => api.get('/releases'),
  getById: (id) => api.get(`/releases/${id}`),
  create: (data) => api.post('/releases', data),
  update: (id, data) => api.put(`/releases/${id}`, data),
  delete: (id) => api.delete(`/releases/${id}`),
  move: (id, direction) => api.post(`/releases/${id}/move`, { direction }),
};

// Artists API
export const artistsAPI = {
  getAll: () => api.get('/artists'),
  getById: (id) => api.get(`/artists/${id}`),
  create: (data) => api.post('/artists', data),
  update: (id, data) => api.put(`/artists/${id}`, data),
  delete: (id) => api.delete(`/artists/${id}`),
  move: (id, direction) => api.post(`/artists/${id}/move`, { direction }),
};

// Merch API
export const merchAPI = {
  getAll: () => api.get('/merch'),
  getById: (id) => api.get(`/merch/${id}`),
  create: (data) => api.post('/merch', data),
  update: (id, data) => api.put(`/merch/${id}`, data),
  delete: (id) => api.delete(`/merch/${id}`),
  move: (id, direction) => api.post(`/merch/${id}/move`, { direction }),
};

export default api;

